import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import * as MessageActions from '../../common/messageBox/actions/actions';

const realmName = 'Toyota';

export const logout = () => {
  return {
    'type': ActionTypes.USER_LOGOUT,
  };
};

export const loginSuccess = (keycloakObject) => {
  return {
    'type': ActionTypes.USER_LOGIN_SUCCESS,
    'payload': keycloakObject,
  };
};

export const getUserInfo = () => apiActionCreator({
  'endpoint': `/realms/${realmName}/protocol/openid-connect/userinfo`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_USER_INFO_REQUEST,
    ActionTypes.GET_USER_INFO_SUCCESS,
    ActionTypes.GET_USER_INFO_FAILED,
  ],
  'microservice': 'auth',
  'method': 'GET',
});

export const updateAccessToken = (accessToken) => {
  return {
    'type': ActionTypes.USER_UPDATE_ACCESS_TOKEN,
    'payload': accessToken,
  };
};

export const loginLogger = () => apiActionCreator({
  'endpoint': '/loginLogger',
  'authenticated': true,
  'types': [
    ActionTypes.SAVING_LOGIN_LOGGER,
    ActionTypes.SAVED_LOGIN_LOGGER,
    ActionTypes.SAVED_LOGIN_LOGGER_FAILED,
  ],
  'microservice': 'part',
  'method': 'POST',
});

export const getPartyToken = () => {
  return apiActionCreator({
    'endpoint': '/authorize',
    'authenticated': true,
    'types': [
      ActionTypes.REQUESTING_PARTY_TOKEN,
      ActionTypes.REQUESTED_PARTY_TOKEN,
      [
        ActionTypes.REQUESTED_PARTY_TOKEN_FAILED,
        MessageActions.addMessageBoxError('Ha ocurrido un error al obtener los permisos del usuario'),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const getLastLogin = () => apiActionCreator({
  'endpoint': '/getLastLogin',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_LAST_LOGIN,
    ActionTypes.FETCHED_LAST_LOGIN,
    [
      ActionTypes.FETCHED_LAST_LOGIN_FAILED,
      (error) => {
        return MessageActions.addMessageBoxError(`${error.data.code} - ${error.data.type}`);
      },
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
